import { render, staticRenderFns } from "./OrderReceipt.vue?vue&type=template&id=bffc2786&scoped=true"
import script from "./OrderReceipt.vue?vue&type=script&lang=ts"
export * from "./OrderReceipt.vue?vue&type=script&lang=ts"
import style0 from "./OrderReceipt.vue?vue&type=style&index=0&id=bffc2786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffc2786",
  null
  
)

export default component.exports